export default __webpack_public_path__ + "static/media/mattia-trani.3378315f.jpg";